module.exports = __webpack_public_path__ + "img/tenant_console_login_img@3x.01f544ff.png";